import React from "react";

export default function SilenceOverviewPage() {
  return (
    <div
      style={{
        maxWidth: 700,
        margin: "48px auto",
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 2px 12px #0001",
        padding: 36,
        fontFamily: "inherit",
        color: "#222",
      }}
    >
           
      <h2 style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
        Моніторинг тиші
      </h2>
                 
      <p style={{ margin: "12px 0", lineHeight: 1.5 }}>
        Забудьте про несподівані «провали» ефіру. Наш сервіс
        {" "}
        <b>цілодобово контролює ваші радіопотоки (MP3 та AAC+)</b>
        {" "}
        і миттєво повідомляє про тишу.
      </p>

      <ul style={{ paddingLeft: 18, margin: "14px 0" }}>
        <li style={{ marginBottom: 8 }}>
          Сповіщення приходять <b>у Telegram</b> одразу після виявлення проблеми.
        </li>
        <li style={{ marginBottom: 8 }}>
          До основного користувача можна додати ще <b>2 контактні особи</b>
          {" "}
          (наприклад, технічну чи програмну службу) — це вже входить у вартість.
        </li>
        <li style={{ marginBottom: 8 }}>
          Доступна <b>7-денна історія рівнів гучності</b> кожного потоку з
          {" "}
          точністю до секунди — ви завжди бачите, що відбувалося в ефірі.
        </li>
      </ul>

      <p style={{ margin: "12px 0", lineHeight: 1.5 }}>
        Проста підключення, без додаткового обладнання. Ваш ефір — під надійним контролем.
      </p>
    </div>
  );
}

